
import { PROJECT_BRANDS } from '@/modules/brand/domain/brand';

export default {
  name: 'WebLogo',

  components: {
    RhLogo: () => import('@/components/ui/RhLogo/RhLogo.vue'),
    MuscleLogo: () => import('@/components/MuscleCharge/MuscleLogo.vue'),
  },

  props: {
    brand: {
      type: String,
      default: PROJECT_BRANDS.reverse,
      validator: (value) => Object.values(PROJECT_BRANDS).includes(value),
    },
    type: {
      type: String,
      default: null,
    },
  },

  computed: {
    getProductType() {
      return this.type;
    },

    isMuscleChargeBrand() {
      return this.brand === PROJECT_BRANDS.muscleCharge;
    },

    currentComponent() {
      return this.isMuscleChargeBrand ? 'MuscleLogo' : 'RhLogo';
    },
  },
};
